import { IconType } from "@/components/Core/AppIcon";
import { routers } from "@/configs";

import { Mode } from "./type";

export const SPORT_PATH_PREFIX = "/sports";

export const OPTIONS: Array<{ mode: Mode; icon: IconType; label: string; to: string }> = [
  {
    mode: "casino",
    icon: "casino",
    label: "casino",
    to: routers.CasinoGame.replace(":code", "lobby"),
  },
  { mode: "sport", icon: "soccer", label: "sport.title", to: routers.SportsLobby },
];
